// extracted by mini-css-extract-plugin
module.exports = {"Small":"Logo_Small__12nXM","Full":"Logo_Full__6IdyA"};